(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["femoire-reference-test"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.fmrReady === '1') return;
    root.dataset.fmrReady = '1';

    var main = root.querySelector('[data-fmr-main]');
    root.querySelectorAll('[data-fmr-shot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.fmrShot + '&width=1000';
        root.querySelectorAll('[data-fmr-shot]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });

    var variantInput = root.querySelector('[data-fmr-variant]');
    var buyBtn = root.querySelector('[data-fmr-buy]');
    root.querySelectorAll('[data-fmr-select]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.dataset.fmrSelect;
        root.querySelectorAll('[data-fmr-tier]').forEach(function (tier) {
          var on = tier.dataset.fmrTier === key;
          tier.classList.toggle('is-selected', on);
          var row = tier.querySelector('[data-fmr-select]');
          if (row) row.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = btn.dataset.fmrVariantId;
        if (buyBtn) buyBtn.textContent = btn.dataset.fmrLabel;
      });
    });

    var proof = root.querySelector('[data-fmr-proof]');
    function step(dir) {
      if (!proof) return;
      var first = proof.firstElementChild;
      var pitch = first ? first.getBoundingClientRect().width + 18 : 338;
      proof.scrollBy({ left: dir * pitch, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-fmr-proof-prev]');
    var next = root.querySelector('[data-fmr-proof-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var stats = root.querySelector('[data-fmr-stats]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (stats && !reduce && 'IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || started) return;
          started = true;
          io.disconnect();
          var items = Array.prototype.slice.call(stats.querySelectorAll('[data-fmr-stat]'));
          var start = null;
          function tick(now) {
            if (start === null) start = now;
            var t = Math.min(1, (now - start) / 1600);
            var eased = 1 - Math.pow(1 - t, 3);
            items.forEach(function (item) {
              var target = parseFloat(item.dataset.fmrStat) || 0;
              var value = target * eased;
              var num = item.querySelector('[data-fmr-num]');
              var fill = item.querySelector('[data-fmr-fill]');
              if (num) num.textContent = Math.round(value) + '%';
              if (fill) fill.style.width = value + '%';
            });
            if (t < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.25 });
      io.observe(stats);
    }

    var bar = root.querySelector('[data-fmr-bar]');
    var pricing = root.querySelector('#fmr-pricing');
    if (bar) {
      var threshold = (parseFloat(root.dataset.stickyThreshold) || 42) / 100;
      var onScroll = function () {
        var d = document.documentElement;
        var max = (d.scrollHeight - d.clientHeight) || 1;
        var p = (window.scrollY || d.scrollTop) / max;
        var pricingVisible = false;
        if (pricing) {
          var r = pricing.getBoundingClientRect();
          pricingVisible = r.top < d.clientHeight * 0.85 && r.bottom > 0;
        }
        bar.hidden = !(p > threshold && p < 0.97 && !pricingVisible);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    root.querySelectorAll('.fmr-vcard__media video').forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.controls = false;
      v.setAttribute('playsinline', '');
      v.setAttribute('aria-hidden', 'true');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  function boot() { document.querySelectorAll('.fmr').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
